export const formatPrice = (price: number | string | undefined): string => {
  if (!price) return "";

  const numericPrice = typeof price === "string" ? parseFloat(price) : price;

  if (isNaN(numericPrice)) return "";

  return new Intl.NumberFormat("ja-JP", {
    style: "currency",
    currency: "JPY",
    useGrouping: true,
  }).format(numericPrice);
};
